import env from '@beam-australia/react-env';
import React from 'react';
import Link from '@mui/material/Link';

const HELP_LINK_ADDRESS = env('HELP_LINK_ADDRESS');

export default function SupportEmailLink() {
  return <Link href={`mailto:${HELP_LINK_ADDRESS}`}>{HELP_LINK_ADDRESS}</Link>;
}
